import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { ADDON_TYPE_NAME_DICT } from "app/contexts/AddonStateContext/const";

interface ISummaryTranslation {
    title: string;
    description: string;
    caption: string;
    selectionPlaceholder: string;
    searchPlaceholder?: string;
    selectText: { [key: string]: string };
}

const summary: Record<AddonTypeName, ISummaryTranslation> = {
    [ADDON_TYPE_NAME_DICT.HistoricalDataDynamic]: {
        title: "no_touch_purchase_modal.summary.history.title",
        description: "no_touch_purchase_modal.summary.history.description",
        caption: "no_touch_purchase_modal.summary.history.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.history.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.history.select_text_0",
            "6": "no_touch_purchase_modal.summary.history.select_text_6",
            "12": "no_touch_purchase_modal.summary.history.select_text_12",
            "15": "no_touch_purchase_modal.summary.history.select_text_15",
        },
    },
    [ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic]: {
        title: "no_touch_purchase_modal.summary.users.title",
        description: "no_touch_purchase_modal.summary.users.description",
        caption: "no_touch_purchase_modal.summary.users.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.users.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.users.select_text_0",
            "1": "no_touch_purchase_modal.summary.users.select_text_1",
            "2": "no_touch_purchase_modal.summary.users.select_text_2",
            "3": "no_touch_purchase_modal.summary.users.select_text_3",
            "4": "no_touch_purchase_modal.summary.users.select_text_4",
        },
    },
    [ADDON_TYPE_NAME_DICT.DataCreditsDynamic]: {
        title: "no_touch_purchase_modal.summary.data.title",
        description: "no_touch_purchase_modal.summary.data.description",
        caption: "no_touch_purchase_modal.summary.data.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.data.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.data.select_text_0",
            "100": "no_touch_purchase_modal.summary.data.select_text_100",
            "250": "no_touch_purchase_modal.summary.data.select_text_250",
            "500": "no_touch_purchase_modal.summary.data.select_text_500",
            "900": "no_touch_purchase_modal.summary.data.select_text_900",
            "2500": "no_touch_purchase_modal.summary.data.select_text_2500",
            "5000": "no_touch_purchase_modal.summary.data.select_text_5000",
        },
    },
    [ADDON_TYPE_NAME_DICT.SiDataCredits1000]: {
        title: "no_touch_purchase_modal.summary.si_data_credits.title",
        description: "no_touch_purchase_modal.summary.si_data_credits.description",
        caption: "no_touch_purchase_modal.summary.si_data_credits.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.si_data_credits.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.si_data_credits.select_text_0",
            "1000": "no_touch_purchase_modal.summary.si_data_credits.select_text_1000",
        },
    },
    [ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic]: {
        title: "no_touch_purchase_modal.summary.projects.title",
        description: "no_touch_purchase_modal.summary.projects.description",
        caption: "no_touch_purchase_modal.summary.projects.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.projects.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.projects.select_text_0",
            "1": "no_touch_purchase_modal.summary.projects.select_text_1",
            "2": "no_touch_purchase_modal.summary.projects.select_text_2",
            "3": "no_touch_purchase_modal.summary.projects.select_text_3",
            "4": "no_touch_purchase_modal.summary.projects.select_text_4",
        },
    },
    [ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic]: {
        title: "no_touch_purchase_modal.summary.campaigns.title",
        description: "no_touch_purchase_modal.summary.campaigns.description",
        caption: "no_touch_purchase_modal.summary.campaigns.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.campaigns.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.campaigns.select_text_0",
            "20": "no_touch_purchase_modal.summary.campaigns.select_text_20",
            "25": "no_touch_purchase_modal.summary.campaigns.select_text_25",
            "30": "no_touch_purchase_modal.summary.campaigns.select_text_30",
            "35": "no_touch_purchase_modal.summary.campaigns.select_text_35",
            "40": "no_touch_purchase_modal.summary.campaigns.select_text_40",
        },
    },
    [ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic]: {
        title: "no_touch_purchase_modal.summary.keywords.title",
        description: "no_touch_purchase_modal.summary.keywords.description",
        caption: "no_touch_purchase_modal.summary.keywords.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.keywords.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.keywords.select_text_0",
            "2500": "no_touch_purchase_modal.summary.keywords.select_text_2500",
            "3000": "no_touch_purchase_modal.summary.keywords.select_text_3000",
            "3500": "no_touch_purchase_modal.summary.keywords.select_text_3500",
            "4000": "no_touch_purchase_modal.summary.keywords.select_text_4000",
            "4500": "no_touch_purchase_modal.summary.keywords.select_text_4500",
            "5000": "no_touch_purchase_modal.summary.keywords.select_text_5000",
        },
    },
    [ADDON_TYPE_NAME_DICT.MonitorAndProtectCrawls]: {
        title: "no_touch_purchase_modal.summary.mp_crawls.title",
        description: "no_touch_purchase_modal.summary.mp_crawls.description",
        caption: "no_touch_purchase_modal.summary.mp_crawls.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.mp_crawls.placeholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.mp_crawls.select_text_0",
            "5000": "no_touch_purchase_modal.summary.mp_crawls.select_text_5000",
            "10000": "no_touch_purchase_modal.summary.mp_crawls.select_text_10000",
            "15000": "no_touch_purchase_modal.summary.mp_crawls.select_text_15000",
            "20000": "no_touch_purchase_modal.summary.mp_crawls.select_text_20000",
        },
    },
    [ADDON_TYPE_NAME_DICT.CountryFilterDynamic]: {
        title: "no_touch_purchase_modal.summary.country_filters.title",
        description: "no_touch_purchase_modal.summary.country_filters.description",
        caption: "no_touch_purchase_modal.summary.country_filters.caption",
        selectionPlaceholder: "no_touch_purchase_modal.summary.country_filters.placeholder",
        searchPlaceholder: "no_touch_purchase_modal.summary.country_filters.searchPlaceholder",
        selectText: {
            "0": "no_touch_purchase_modal.summary.country_filters.select_text_0",
        },
    },
} as const;

const details = {
    details: {
        caption: "no_touch_purchase_modal.summary.details_caption",
        vat: "no_touch_purchase_modal.summary.details_vat",
        dueToday: "no_touch_purchase_modal.summary.details_due_today",
        nextBilling: "no_touch_purchase_modal.summary.details_next_billing",
        paymentMemo: "no_touch_purchase_modal.summary.details_payment_memo",
        buttonText: "no_touch_purchase_modal.summary.details_button_text",
        info: "no_touch_purchase_modal.summary.info",
        infoTooltip: "no_touch_purchase_modal.summary.info_tooltipv3",
        safePayment: "no_touch_purchase_modal.summary.safe_payment",
        periodTextMonthly: "no_touch_purchase_modal.summary.period_text_monthly",
        periodTextAnnually: "no_touch_purchase_modal.summary.period_text_annually",
        youAccept: "no_touch_purchase_modal.summary.you_accept",
        tos: "no_touch_purchase_modal.summary.tos",
    },
    selectionPeriodMonth: "no_touch_purchase_modal.summary.selection_period_month",
    selectionPeriodYear: "no_touch_purchase_modal.summary.selection_period_year",
    errorText: "no_touch_purchase_modal.summary.error",
} as const;

const suggestions = {
    caption: "no_touch_purchase_modal.suggestions.caption",
    bottomText: "no_touch_purchase_modal.suggestions.bottom_text",
    bottomTextLink: "no_touch_purchase_modal.suggestions.bottom_text_link",
    [ADDON_TYPE_NAME_DICT.HistoricalDataDynamic]: {
        title: "no_touch_purchase_modal.suggestions.history.title",
        description: "no_touch_purchase_modal.suggestions.history.description",
    },
    [ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic]: {
        title: "no_touch_purchase_modal.suggestions.users.title",
        description: "no_touch_purchase_modal.suggestions.users.description",
    },
    [ADDON_TYPE_NAME_DICT.DataCreditsDynamic]: {
        title: "no_touch_purchase_modal.suggestions.data.title",
        description: "no_touch_purchase_modal.suggestions.data.description",
    },
    [ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic]: {
        title: "no_touch_purchase_modal.suggestions.projects.title",
        description: "no_touch_purchase_modal.suggestions.projects.description",
    },
    [ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic]: {
        title: "no_touch_purchase_modal.suggestions.campaign.title",
        description: "no_touch_purchase_modal.suggestions.campaign.description",
    },
    [ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic]: {
        title: "no_touch_purchase_modal.suggestions.keywords.title",
        description: "no_touch_purchase_modal.suggestions.keywords.description",
    },
    [ADDON_TYPE_NAME_DICT.MonitorAndProtectCrawls]: {
        title: "no_touch_purchase_modal.suggestions.mp_crawls.title",
        description: "no_touch_purchase_modal.suggestions.mp_crawls.description",
    },
} as const;

const success = {
    purchaseSuccessful: "no_touch_purchase_modal.success.purchase_successful",
    purchaseSuccessfulText: "no_touch_purchase_modal.success.purchase_successful_text",
    purchaseInProgress: "no_touch_purchase_modal.success.purchase_in_progress",
    done: "no_touch_purchase_modal.success.done",
};

const paymentFailure = {
    title: "no_touch_purchase_modal.payment_failure.title",
    description: "no_touch_purchase_modal.payment_failure.description",
    updatePaymentMethod: "no_touch_purchase_modal.payment_failure.update_payment_method",
    needHelp: "no_touch_purchase_modal.payment_failure.need_help",
    contactBilling: "no_touch_purchase_modal.payment_failure.contact_billing",
    illustrationAlt: "no_touch_purchase_modal.payment_failure.illustration_alt",
};

const periods = {
    monthly: "no_touch_purchase_modal.summary.period_month",
    annually: "no_touch_purchase_modal.summary.period_annual",
};

export const NO_TOUCH_PURCHASE_TRANSLATIONS = {
    summary,
    details,
    suggestions,
    success,
    paymentFailure,
} as const;

export const discount = {
    addonsPercentOff: "addons.percent.off",
    addonsDiscountOff: "addons.discount.off",
} as const;
